(function() { module.exports = this["wp"]["dom"]; }());